/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycComplianceReportDto } from '../../models/kyc-compliance-report-dto';

export interface GetComplianceReport$Params {
  processId: string;
}

export function getComplianceReport(http: HttpClient, rootUrl: string, params: GetComplianceReport$Params, context?: HttpContext): Observable<StrictHttpResponse<KycComplianceReportDto>> {
  const rb = new RequestBuilder(rootUrl, getComplianceReport.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycComplianceReportDto>;
    })
  );
}

getComplianceReport.PATH = '/kyc/processes/{processId}/compliance-report';
